<template>
  <div>
    <template v-if="detalhesRh && detalhesRh.length > 0">
      <div class="table-outer-title d-flex align-center justify-space-between">
        <div class="font-weight-bold text-uppercase pl-5">
          Detalhes — Recursos Humanos
        </div>
        <div style="width: 50%">
          <v-pagination
            v-model="rhPage"
            :length="detalhesRh.length"
            :total-visible="7"
          ></v-pagination>
        </div>
      </div>
      <v-carousel
        v-model="rhPanel"
        class="mb-3"
        hide-delimiters
        :show-arrows="false"
        :height="'fit-content'"
      >
        <v-carousel-item
          v-for="(rh, index) in detalhesRh"
          :key="index"
          class="table-container"
        >
          <table>
            <tr>
              <th style="width: 25%">Nome</th>
              <td style="width: 25%">{{ rh.participante_nome }}</td>
              <th style="width: 25%">CPF</th>
              <td style="width: 25%">{{ rh.participante_cpf }}</td>
            </tr>
            <tr>
              <th>Escolaridade</th>
              <td>{{ rh.nivel_escolaridade }}</td>
              <th>Tipo RH</th>
              <td>{{ rh.tipo_rh }}</td>
            </tr>
            <tr>
              <th>Total de Horas</th>
              <td>{{ rh.horas_trabalhadas }}</td>
              <th>Total Gasto</th>
              <td>{{ rh.valor_total | toCurrency }}</td>
            </tr>
          </table>
          <table>
            <tr>
              <th style="width: 50%">Valor</th>
              <th style="width: 50%">Atuação</th>
            </tr>
            <tr v-for="(d, di) in rh.despesas" :key="di">
              <td>{{ d.valor | toCurrency }}</td>
              <td>{{ d.atuacao_projeto }}</td>
            </tr>
          </table>
        </v-carousel-item>
      </v-carousel>
    </template>

    <div v-else class="pa-5 text-center grey--text">
      Nenhuma despesa de RH registrada para este projeto.
    </div>
  </div>
</template>

<script>
export default {
  name: "DetalhesRh",
  props: {
    detalhesRh: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rhPanel: 0,
    };
  },
  computed: {
    rhPage: {
      get() {
        return this.rhPanel + 1;
      },
      set(value) {
        this.rhPanel = value - 1;
      },
    },
  },
  watch: {
    detalhesRh() {
      // Reset the carousel to the first page when/if the data changes
      this.rhPanel = 0;
    },
  },
};
</script>

<style lang="scss" scoped src="../styles/report.scss"></style>